// Il backend serializza gli enum come stringa (JsonStringEnumConverter),
// quindi "value" deve corrispondere al nome del membro C# di StatoManutenzione.
export const STATI_MANUTENZIONE = [
    { label: "Pianificata", value: "Pianificata" },
    { label: "In corso", value: "InCorso" },
    { label: "Completata", value: "Completata" },
    { label: "Annullata", value: "Annullata" },
];

const COLORI_STATO = {
    Pianificata: "success",
    InCorso: "orange",
    Completata: "info",
    Annullata: "grey",
};

export function coloreStatoManutenzione(stato) {
    return COLORI_STATO[stato] || "grey";
}

export function etichettaStatoManutenzione(stato) {
    return (STATI_MANUTENZIONE.find(s => s.value === stato) || {}).label || "";
}
